import { memo } from 'react';
import JackpotProgress from './JackpotProgress/JackpotProgress';
import JackpotFooter from './JackpotFooter/JackpotFooter';

function CommunityJackpot() {
  return (
    <>
      <JackpotProgress showLastMilestoneHit={false} />
      <JackpotFooter />
    </>
  );
}

export default memo(CommunityJackpot);
